import styled from 'styled-components'

import { SecondaryButton } from '../shared/styledComponents'

const Container = styled.div`
  width: 650px;
  box-sizing: border-box;
  margin: 130px auto 40px auto;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.2px;
  border: 1px solid #cbcbcb;
  background-color: #ffffff;
  @media (max-width: 768px) {
    border: none;
    width: 100%;
  }
`

const Content = styled.div`
  width: 400px;
  box-sizing: border-box;
  margin: 0 auto 40px auto;
  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
    padding-left: 18px;
    padding-right: 18px;
  }
`

const BigImg = styled.div`
  margin: -60px auto 0 auto;
  display:flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 768px) {
    margin-top: -200px;
  }
`

const ButtonIcon = styled.span`
  margin-right: 8px;
  top: 4px;
  position: relative;
`

const ButtonText = styled.span`
  line-height: 2.2;
`

const FileListItem = styled.ul`
  list-style-type: none;
  margin: 0px;
`

const List = styled.div<{ background: string }>`
  background-color: ${props => props.background};
  font-family: NeueHaasUnica, sans-serif;
  font-size: 15px;
  line-height: 1.47;
  letter-spacing: -0.2px;
  color: ${props => props.color};
  padding: 0px;
  margin: 12px 0;
  opacity: 1;
  width: 100%;
  padding-top: 8px;
  width:100%;
`
const HeaderThree = styled.h3`
  font-family: NeueHaasUnica, sans-serif;
  font-size: 18px;
  line-height: 36px;
  letter-spacing: 0.2px;
  font-weight: bold;
  height: 40px;
`

const MessageBodyListHeaderBold = styled.div`
  font-family: NeueHaasUnica, sans-serif;
  font-size: 12px;
  line-height: 27px;
  letter-spacing: 1.5px;
  list-style-type: none;
  margin-left: 75px;
  font-weight: bold;
`

const MessageBodyListBody = styled.div`
  font-family: NeueHaasUnica, sans-serif;
  font-size: 12px;
  line-height: 27px;
  letter-spacing: 1.5px;
  list-style-type: none;
  margin-left: 30px;
`

const MessageBodyCenter = styled.div`
  text-align: center;
  font-family: NeueHaasUnica, sans-serif;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 0.2px;
`

const MessageBodyCenterFailure = styled.div`
  text-align: center;
  font-family: NeueHaasUnica, sans-serif;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 0.2px;
  width: 102%;
`

const MessageBold = styled.span`
  font-weight: bold;
`

const MessageListBodyCenterBold = styled.div`
  text-align: center;
  font-family: NeueHaasUnica, sans-serif;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.2px;
  margin-bottom: 6px;
  font-weight: bold;
`

const MessageBodyCenterSmall = styled.div`
  text-align: center;
  font-family: NeueHaasUnica, sans-serif;
  font-size: 12px;
  line-height: 36px;
  letter-spacing: 0.2px;
`

const MessageBodyCenterBold = styled.div`
  text-align: center;
  font-family: NeueHaasUnica, sans-serif;
  font-size: 14px;
  line-height: 36px;
  letter-spacing: 0.2px;
  font-weight: bold;
`

const IconButton = styled(SecondaryButton)`
  float: none;
  width: 100%;
  margin:0;
  padding: 0 0 8px 0;
  line-height: 1.33;
  letter-spacing: 1px;
`

const CenterButtons = styled.div`
  box-sizing: border-box;
  margin: 18px auto;
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
    margin: 18px 0;
    padding-left: 18px;
    padding-right: 18px;
  }
`

const BackToTheFront = styled.a`
  display: block;
  font-family: NeueHaasUnica, sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 2;
  letter-spacing: 0px;
  text-align: center;
  color: #007395;
  text-decoration: none;
  width: 60%;
  margin: 20px auto 0 auto;
`

export {
  BackToTheFront,
  BigImg,
  ButtonIcon,
  ButtonText,
  CenterButtons,
  Container,
  Content,
  FileListItem,
  HeaderThree,
  IconButton,
  List,
  MessageBodyCenter,
  MessageBodyCenterBold,
  MessageBodyCenterFailure,
  MessageBodyCenterSmall,
  MessageBodyListBody,
  MessageBodyListHeaderBold,
  MessageBold,
  MessageListBodyCenterBold
}
